module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-sound_off@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-sound_off@2x.png
// module id = 654
// module chunks = 0